export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-br from-primary-500 via-primary-600 to-primary-800 rounded-2xl overflow-hidden">
            <div className="flex flex-col lg:flex-row items-center">
              <div className="flex-1 p-8 md:p-12 text-center lg:text-left">
                <h2 className="text-2xl md:text-3xl font-bold font-heading text-white">
                  移动追剧
                </h2>
                <p className="mt-3 text-sm text-white/80 leading-relaxed max-w-md">
                  日韩影视网全面适配手机与平板，无需下载APP，打开浏览器即可享受高清追剧体验。横屏竖屏自适应，随时随地畅享日韩好剧。
                </p>

                <div className="mt-6 flex flex-wrap items-center gap-4 justify-center lg:justify-start">
                  <div className="flex items-center gap-2 text-white/90 text-sm">
                    <i className="ri-smartphone-line text-lg"></i>
                    <span>手机适配</span>
                  </div>
                  <div className="flex items-center gap-2 text-white/90 text-sm">
                    <i className="ri-tablet-line text-lg"></i>
                    <span>平板适配</span>
                  </div>
                  <div className="flex items-center gap-2 text-white/90 text-sm">
                    <i className="ri-fullscreen-line text-lg"></i>
                    <span>横屏观影</span>
                  </div>
                </div>

                <a
                  href="#hero"
                  className="mt-6 inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-white text-primary-600 hover:bg-white/90 font-medium text-sm transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-play-circle-line text-lg"></i>
                  立即开始追剧
                </a>
              </div>

              <div className="flex-1 p-6 md:p-8 flex justify-center">
                <div className="relative">
                  <div className="w-48 md:w-56 aspect-[9/16] rounded-2xl border-2 border-white/20 overflow-hidden bg-background-950/30">
                    <img
                      src="https://readdy.ai/api/search-image?query=Mobile%20phone%20screen%20mockup%20displaying%20drama%20streaming%20interface%20with%20poster%20thumbnails%2C%20dark%20theme%20UI%20with%20warm%20accent%20colors%2C%20clean%20modern%20video%20platform%20design%2C%20Japanese%20Korean%20drama%20app%20aesthetic%2C%20minimal%20interface&width=600&height=1067&seq=app-mobile-drama&orientation=portrait"
                      alt="日韩影视网移动端追剧界面"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="absolute -top-3 -right-3 w-10 h-10 flex items-center justify-center rounded-full bg-accent-500">
                    <i className="ri-flashlight-line text-white text-lg"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}